import filterParams from './filter_params';

document.addEventListener("turbolinks:load", () => {
  const managerFilterSelect = document.querySelector('#employees-manager-select');
  if (managerFilterSelect) {
    const managerOptionMarkup = (managerData) => {
      if (!managerData.id) return managerData.text;

      const fullName = managerData.full_name || managerData.element?.dataset.fullName || managerData.text;
      const identifier = managerData.identifier || managerData.element?.dataset.identifier || '';
      const option = $('<div />', { class: 'select2-manager-option' });
      option.append($('<div />', { class: 'select2-manager-option__name', text: fullName }));
      option.append($('<div />', { class: 'select2-manager-option__identifier', text: identifier }));
      return option;
    };

    const managerSelectionMarkup = (managerData) => {
      if (!managerData.id) return managerData.text;

      const fullName = managerData.full_name || managerData.element?.dataset.fullName || managerData.text;
      return $('<span />', { text: fullName });
    };

    const $managerFilterSelect = $(managerFilterSelect);
    if ($managerFilterSelect.hasClass('select2-hidden-accessible')) {
      $managerFilterSelect.select2('destroy');
    }

    $managerFilterSelect.select2({
      placeholder: 'Manager',
      allowClear: true,
      width: '100%',
      minimumInputLength: 1,
      ajax: {
        url: managerFilterSelect.dataset.remoteUrl,
        dataType: 'json',
        delay: 300,
        data: (params) => ({ q: params.term }),
        processResults: (data) => ({ results: data.results || [] })
      },
      templateResult: managerOptionMarkup,
      templateSelection: managerSelectionMarkup
    });
  }

  const clearTextSearch = document.querySelector('#clear-text-search')
  if (clearTextSearch) {
    clearTextSearch.addEventListener('click', () => filterParams('q'));
  }

  // Employees backup search form
  const searchForm = document.querySelector('#personSearch');
  const employeeId = document.querySelector('#employee-id');

  if (searchForm && employeeId) {
    searchForm.querySelector('#searchResults').addEventListener('click', (e) => {
      if (e.target.tagName === 'LI') {
        employeeId.value = e.target.dataset.personId;
      }
    });

    // Search field will be cleared when clicking on it
    // so we need to clear the employeeId field as well
    searchForm.querySelector('#search').addEventListener('click', (e) => {
      if (e.target.value.length) { employeeId.value = null; }
    });
  }

  const newPassword = document.querySelector('input#employee_new_password');
  const confirmPassword = document.querySelector('input#employee_password_confirmation');
  if (newPassword && confirmPassword) {
    const passwordNoMatchError = document.querySelector('#password-no-match-error');
    confirmPassword.addEventListener('keyup', (e) => {
      if (e.target.value !== newPassword.value) {
        passwordNoMatchError.classList.remove('hidden');
      } else {
        passwordNoMatchError.classList.add('hidden');
      }
    });
  }
});
